/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFile200,
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFile401,
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFile404,
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFile500,
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFilePathParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoiceFileQueryResponse,
} from "../../types/individualPaymentInvoicesController/GetApiV1IndividualpaymentParcelsParcelidInvoiceFile.ts";

export const getApiV1IndividualpaymentParcelsParcelidInvoiceFilePathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFilePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoiceFile200Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFile200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoiceFile401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFile401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoiceFile404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFile404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoiceFile500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFile500>;

export const getApiV1IndividualpaymentParcelsParcelidInvoiceFileQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelidInvoiceFile200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoiceFileQueryResponse>;
